import { configureIguazuREST } from 'iguazu-rest';
import { treatments } from './utility';
import memberProducts from './memberProducts';
import { getModuleState } from './selectors';

export const configureIguazuResources = () => {
  configureIguazuREST({
    getToState: (state) => getModuleState(state).getIn(['resources']),
    defaultOpts: {
      credentials: 'include',
    },
    resources: {
      treatments,
      memberProducts,
    },
  });
};
